import PricePerTime from './PricePerTime.js';

export default class ClubSalesListOfferingItem {
    static fromData(data) {
        if (!data) {
            return;
        }

        const offeringItem = new ClubSalesListOfferingItem();
        offeringItem.id = data.id;
        offeringItem.clubFeeId = data.clubFeeId;
        offeringItem.clubFeeName = data.clubFeeName;
        offeringItem.pricePerTime = PricePerTime.fromData(data.pricePerTime.data);

        return offeringItem;
    }
}
